import {StaticImageData} from "next/image";

export const addDataToTranslatedArray = <T extends object>(translatedData: T[], data: (() => JSX.Element)[] | StaticImageData[], title: string): (T & Record<string, unknown>)[] => {
    return translatedData.map((item, index: number) => ({...item, [title]: data[index]}));
};